import packageJson from '../package.json';

// Versão do front lida direto do package.json — basta dar `npm version patch`
// (ou editar à mão) pra refletir aqui automaticamente.
export const FRONT_VERSION = packageJson.version;

// Versão da API mantida manualmente aqui (o backend ainda não expõe a própria
// versão por um endpoint) — atualizar sempre que o horus-node passar pela
// pipeline com uma mudança real de código.
export const API_VERSION = '1.0.0';
